import { PartialSite, Site } from "../models/site";
import axiosConfig from "./axiosConfig";

const putSite = async (
  authToken: string,
  siteId: string,
  userOrgId: string | undefined,
  update: PartialSite
): Promise<Site> => {
  const { data } = await axiosConfig.put(
    `/site/${siteId}${userOrgId ? `?userOrgId=${userOrgId}` : ""}`,
    update,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default putSite;
